VLW.controllers.EavActu = class extends VLW.controllers.base_mc {
	constructor(a, b) {
		super(a, b);
	}
	
	onRender() {
		super.onRender();
		let tl = new TimelineMax();
		tl.addLabel("start");
		tl.fromTo(this.qsa("._filet._top"), 1.25, {y: 75}, {y: 0, ease: Sine.easeInOut}, "start");
		tl.fromTo(this.qsa("._filet._bottom"), 1.25, {y: -75}, {y: 0, ease: Sine.easeInOut}, "start");
		tl.fromTo(this.qsa("._doubleFilet._bottom"), 1.25, {y: -75}, {y: 0, ease: Sine.easeInOut}, "start");
		tl.fromTo(this.qsa("._filet"), 1.25, {opacity: 0}, {opacity: .7, ease: Sine.easeInOut}, "start");
		tl.staggerFromTo(this.qsa("._filet"), 1.25, {scaleX: .01}, {scaleX: 1, ease: Sine.easeInOut, clearProps: "transform", onComplete: () => {this.qsa && this.qsa("._filet").map((elt) => elt.classList.add("__transitionable"))}}, .1, "start+=1");
	}
};




